import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController
  @values = {subdirs: Object}
  @targets: ['command', 'category', 'pictureId', 'pictureUpload', 'pictureDirectory',
             'fillerId', 'fillerUpload', 'fillerDirectory',
             'selectionScriptId', 'selectionScriptUpload', 'selectionScriptDirectory',
             'modelFileId', 'modelFileUpload', 'modelFileDirectory', 'studentInterfaceId', 'studentInterfaceUpload',
             'studentInterfaceDirectory', 'assetName', 'assetPath', 'assetType', 'assetUpload',
             'consumer', 'provider', 'projects', 'school', 'json', 'dataset']

  # Store initial value of projects selector
  initialize: -> $(@projectsTarget).prop 'previous', $(@projectsTarget).val() if @hasProjectsTarget

  # Reload problem & problem set new page when package changes
  reload: (event) ->
    if package_id = event.target.value
      $(window.location).prop 'search', "#{event.params.package}[package_id]=#{package_id}"

  # Update fields for asset type
  assetTypeTargetConnected: -> @toggleRequired()

  # Select input boxes on focus
  selectOnFocus: (event) -> $(event.target).select()

  # Toggle category and parent field for categories
  toggleCategory: (event) ->
    value = $(event.target).val()
    $(@categoryTargets).prop('disabled', value isnt 'standards').
      val (i) => if value is 'standards' and i is 0 then 'standard' else ''

  # Toggle selection command field for problem sets
  toggleCommand: (event) ->
    value = $(event.target).val()
    $(@commandTarget).prop 'disabled', value not in ['remote_selection', 'external_selection', 'local_selection']
    $(@commandTarget).prop 'required', value in ['remote_selection', 'external_selection']
    $(@commandTarget).val '' unless value in ['remote_selection', 'external_selection', 'local_selection']
    $([@selectionScriptIdTarget, @selectionScriptUploadTarget, @selectionScriptDirectoryTarget]).
      prop 'disabled', value isnt 'local_selection'
    $([@selectionScriptIdTarget, @selectionScriptUploadTarget]).prop 'required', value is 'local_selection'
    $([@selectionScriptIdTarget, @selectionScriptUploadTarget, @selectionScriptDirectoryTarget]).val '' \
      unless value is 'local_selection'

  # Reset input file fields for problems & problem sets
  resetFile: (event) ->
    hasIdTarget = "has#{event.params.group.upcaseFirst()}IdTarget"
    idTarget = "#{event.params.group}IdTarget"
    uploadTarget = "#{event.params.group}UploadTarget"
    directoryTarget = "#{event.params.group}DirectoryTarget"
    if $(@[uploadTarget]).val()
      $(@[idTarget]).prop 'required', true if $(@[uploadTarget]).prop 'required'
      $(@[directoryTarget]).prop 'required', false
      $([@[uploadTarget], @[directoryTarget]]).val ''

  # Toggle file fields for problems & problem sets
  toggleFileSelect: (event) ->
    uploadTarget = "#{event.params.group}UploadTarget"
    directoryTarget = "#{event.params.group}DirectoryTarget"
    value = $(event.target).val()
    if $(event.target).prop('required') || $(@[uploadTarget]).prop('required')
      $(event.target).prop 'required', true
      $(@[uploadTarget]).prop 'required', !value
    $([@[uploadTarget], @[directoryTarget]]).val '' if value

  toggleFileUpload: (event) ->
    hasIdTarget = "has#{event.params.group.upcaseFirst()}IdTarget"
    idTarget = "#{event.params.group}IdTarget"
    directoryTarget = "#{event.params.group}DirectoryTarget"
    if @[hasIdTarget] && $(@[idTarget]).prop 'required'
      $(event.target).prop 'required', true
      $(@[idTarget]).prop 'required', false if @[hasIdTarget]
    $(@[idTarget]).val '' if @[hasIdTarget]
    unless $(@[directoryTarget]).val()
      type = '.' + $(event.target).val().split('\\')[2].split('.').slice(-1)[0]
      path = if event.params.group in ['picture', 'filler'] then @subdirsValue['.asset'] else @subdirsValue[type]
      $(@[directoryTarget]).val path

# Reset input file fields for assets
  resetAssetFile: (event) ->
    if $(@assetUploadTarget).val()
      $(@assetUploadTarget).prop 'required', true
      $([@assetNameTarget, @assetPathTarget, @assetUploadTarget]).val ''

  # Toggle file fields for assets
  toggleAssetType: (event) ->
    $(@assetNameTarget).val ''
    $(@assetPathTarget).val @subdirsValue['']
    directoryClicked = $(event.target).val() == 'directory' && $(event.target).prop('checked')
    $(@assetUploadTarget).prop 'required', !directoryClicked
    @toggleRequired()

  toggleRequired: ->
    directoryClicked = $(@assetTypeTargets).filter(':checked').val() == 'directory'
    $(@assetNameTarget).prop 'required', directoryClicked
    if @hasAssetUploadTarget
      $(@assetUploadTarget).val '' if directoryClicked
      $(@assetUploadTarget).prop 'disabled', directoryClicked

  # Fill file fields for assets
  fillAssetFields: (event) ->
    if value = $(event.target).val()
      name = value.split('\\')[2]; components = name.split('.')
      type = '.' + components.slice(-1)[0]; subtype = '.' + components.slice(-2).join('.')
      oldType = '.' + $(@assetNameTarget).val().split('.').slice(-1)[0]
      $(@assetNameTarget).val name
      unless $(@assetPathTarget).val() and type is oldType
        $(@assetPathTarget).val @subdirsValue[subtype] || @subdirsValue[type] || @subdirsValue['.asset']

  # Toggle consumer & provider fields for schools
  toggleConsumer: (event) -> $(@consumerTargets).prop 'disabled', $(event.target).prop 'checked'
  toggleProvider: (event) -> $(@providerTargets).prop 'disabled', $(event.target).prop 'checked'

  # Toggle log text fields for schools
  toggleDataset: (event) ->
    $(@datasetTarget).val '' unless $(event.target).val()
    $(@datasetTarget).prop 'disabled', !$(event.target).val()

  # Toggle user projects
  toggleProjects: (event) ->
    developer = /Administrator|Experimenter|Developer/.test $(event.target).find('option:selected').text()
    $(@projectsTarget).val [] unless developer
    $(@projectsTarget).prop 'disabled', not developer

  # Filter user projects so lower subprojects are disjoint from higher ones
  filterProjects: (event) ->
    if (current = $(@projectsTarget).val().find (value) => !$(@projectsTarget).prop('previous').includes(value))?
      $(@projectsTarget).val $(@projectsTarget).val().filter (value) =>
        value is current or not value.startsWith(current + '/') and not current.startsWith(value + '/')
    $(@projectsTarget).prop 'previous', $(@projectsTarget).val()

  # Toggle schools for contact
  toggleSchool: (event) ->
    teacher = /Teacher/.test $(event.target).find('option:selected').text()
    $(@schoolTargets).val '' unless teacher
    $(@schoolTargets).prop 'disabled', not teacher

  # Check JSON fields
  checkJSON: (event) ->
    try
      JSON.parse($(event.target).val())
      event.target.setCustomValidity('')
    catch
      event.target.setCustomValidity('Invalid JSON')
